export default "__VITE_ASSET__3PYz2P1g__"